export default function () {
  const widgetName = 'moreCardsWidget';
  const widgetOpts = moreCardsWidgetOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,

    cardWidgetLoaded: function (data) {

      let totalItemsLoaded = data.items.length;

      $(`#${widgetName} .card-widget-item`).each(function (x) {
        $(this).find('.image-container, .card-content').remove();

        $(this).append(`
        <div class="inner-container">
        <img src="${data.items[x].ImageWithPath}" alt="${data.items[x].ImageAlternateText}">
        <div class="card-title">
        <h3>${data.items[x].Title}</h3>
        </div>
        </div>`)

        $(this).removeAttr('target');

        if (data.items[x].URL == null) {
          $(this).removeAttr('href');
        }

        if (totalItemsLoaded < 4) {
          $(`#${widgetName}`).addClass('threeCards')
        }
      })

    },
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: ['all'],
    maxItemsVisible: 4,
    moreButton: {
      visible: false,
      text: 'Learn More'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: false
  });

}